import React from "react";
import { COMPANY_NAME, BUSINESS_NAME, FASTBOOKING_FOOTER } from "config";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
      <div className="flex w-full flex-col items-center justify-between px-4 pb-8 pt-3 lg:px-8 xl:flex-row">

        {/* Sol Kısım: Müşteri Telif Hakkı */}
        <p className="mb-4 text-center text-sm font-medium text-gray-600 dark:text-gray-400 sm:!mb-0 md:text-base">
          © {currentYear} <span className="font-bold text-navy-700 dark:text-white">{FASTBOOKING_FOOTER}</span>. Tüm hakları saklıdır.
        </p>

        {/* Sağ Kısım: Powered By */}
        <div>
          <ul className="flex flex-wrap items-center justify-center gap-1.5 text-sm font-medium text-gray-600 dark:text-gray-400 sm:flex-nowrap md:text-base">
            <li>Powered by</li>
            <li>
              <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.vireliosoft.com"
                  className="font-bold text-brand-500 hover:text-brand-600 dark:text-brand-400 dark:hover:text-brand-300 transition-colors"
              >
                {COMPANY_NAME}
              </a>
            </li>
            <li className="text-gray-400 dark:text-gray-500">|</li>
            <li>
              <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.randevupp.com"
                  className="font-bold text-brand-500 hover:text-brand-600 dark:text-brand-400 dark:hover:text-brand-300 transition-colors"
              >
                {BUSINESS_NAME}
              </a>
            </li>
          </ul>
        </div>

      </div>
  );
};

export default Footer;